import { MdOutlinePhoneInTalk } from "react-icons/md";
import { BasketIcon, PhoneAltIcon, SalesIcon, ReceiptIcon } from "../assets/icons/audio-icons";

export default {
  total_calls: {
    description: "Total Calls",
    icon: MdOutlinePhoneInTalk,
    text_color: "text-white",
    kpi_text_color: "text-primary",
    bg_color: "bg-primary",
  },
  outgoing_calls_count: {
    description: "Outgoing calls",
    subtitle: "rep.",
    icon: PhoneAltIcon,
    text_color: "text-white",
    kpi_text_color: "text-primary",
    bg_color: "bg-primary",
  },
  average_basket: {
    description: "Average basket",
    subtitle: "rep. /day",
    icon: BasketIcon,
    text_color: "text-white",
    kpi_text_color: "text-primary",
    bg_color: "bg-primary",
  },
  company_average_basket: {
    description: "Company Average basket",
    subtitle: "rep. /day",
    icon: BasketIcon,
    text_color: "text-white",
    kpi_text_color: "text-primary",
    bg_color: "bg-primary",
  },
  average_revenue: {
    description: "Sales",
    subtitle: "rep. /day",
    icon: ReceiptIcon,
    text_color: "text-white",
    kpi_text_color: "text-primary",
    bg_color: "bg-primary",
  },
  total_revenue: {
    description: "Total Sales",
    icon: SalesIcon,
    text_color: "text-white",
    kpi_text_color: "text-primary",
    bg_color: "bg-primary",
  },
};
